import { render, staticRenderFns } from "./BoundaryArea.vue?vue&type=template&id=0434c4f8&"
import script from "./BoundaryArea.vue?vue&type=script&lang=js&"
export * from "./BoundaryArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports